import { render, staticRenderFns } from "./NumberPageMobile.vue?vue&type=template&id=70af0a84&"
import script from "./NumberPageMobile.vue?vue&type=script&lang=js&"
export * from "./NumberPageMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports